import styled from 'styled-components';

const AccordionContainer = styled.div`
  padding-top: 18.5px;
  margin: auto;
  align-self: stretch;
  width: 100%;
  @media screen and (min-width: 768px) {
    padding-top: 12px;
  }
`;

export default AccordionContainer;
